<template>
  <BaseIconTooltip :color="iconData.color"
                   :iconType="iconData.type"
                   :message="iconData.message"
  />
</template>

<script>
import BaseIconTooltip from './BaseIconTooltip';

export default {
  components: { BaseIconTooltip },
  props: {
    searchValue: Boolean,
  },
  computed: {
    iconData() {
      return this.searchValue
        ? {
            color: 'green',
            type: 'check',
            message: 'Entity is in vicinity of the address',
          }
        : {
            color: 'gray',
            type: 'highlight_off',
            message: 'Entity is not in vicinity of the address',
          };
    },
  },
};
</script>

<style>
</style>
